import React, { useState } from 'react';
import { Section, Container, Card } from '../common';
import { 
  BarChart3,
  ChefHat,
  Send, Bot, Gift, Users, Star, Ticket, Smartphone, QrCode, 
  Monitor, Calendar, DollarSign, Package, MapPin, Tablet, Check, PlugZap, RotateCcw, UserX
} from 'lucide-react';

const categories = [
  {
    id: 'vendas',
    title: 'Ferramentas de vendas',
    features: [
      {
        icon: <Send size={32} className="text-primary-custom" />,
        title: 'Disparador de campanhas no WhatsApp',
        description: 'Envie promoções, novidades e ofertas diretamente para seus clientes pelo WhatsApp. Crie campanhas em poucos cliques e aumente seus pedidos sem precisar investir em marketplaces.',
        benefits: ['envie promoções em massa', 'recupere clientes que não pedem há tempo', 'divulgue novos produtos', 'aumente as vendas em horários estratégicos']
      },
      {
        icon: <Bot size={32} className="text-primary-custom" />,
        title: 'Automação inteligente de atendimento',
        description: 'Automatize respostas, pedidos e atendimento no WhatsApp. Seu cliente recebe respostas rápidas enquanto sua equipe ganha tempo para focar na operação.',
        benefits: ['respostas automáticas', 'atendimento 24h', 'menos erros nos pedidos', 'mais agilidade no atendimento']
      },
      {
        icon: <Gift size={32} className="text-primary-custom" />,
        title: 'Cashback para recompra',
        description: 'Incentive seus clientes a voltarem com cashback, saldo em carteira, extrato e regras comerciais configuráveis.',
        benefits: ['saldo de cashback por cliente', 'extrato de movimentações', 'incentivo direto à recompra', 'mais relacionamento com seus clientes']
      },
      {
        icon: <Users size={32} className="text-primary-custom" />,
        title: 'Gestão de clientes',
        description: 'Centralize a base de clientes do restaurante com histórico, contatos, consumo e indicadores de relacionamento para agir com mais precisão.',
        benefits: ['histórico de pedidos por cliente', 'ticket médio e total comprado', 'busca por nome, telefone ou CPF', 'visão de clientes recorrentes e inativos']
      },
      {
        icon: <UserX size={32} className="text-primary-custom" />,
        title: 'Bloqueio de clientes',
        description: 'Controle clientes problemáticos sem perder rastreabilidade, registrando bloqueios, desbloqueios, motivos e histórico da ação.',
        benefits: ['bloqueio com motivo obrigatório', 'desbloqueio pelo portal', 'histórico de bloqueios', 'mais controle sobre pedidos indevidos']
      },
      {
        icon: <Star size={32} className="text-primary-custom" />,
        title: 'Avaliações de pedidos',
        description: 'Colete notas e comentários dos clientes depois da compra, acompanhe a média do restaurante e responda rapidamente aos pontos críticos.',
        benefits: ['convites de avaliação por pedido', 'média de notas e volume avaliado', 'filtro de avaliações baixas', 'configuração de nota crítica']
      },
      {
        icon: <RotateCcw size={32} className="text-primary-custom" />,
        title: 'Recuperador de vendas',
        description: 'Identifique oportunidades em carrinhos abandonados, clientes inativos e campanhas para reativar pedidos com ações registradas.',
        benefits: ['oportunidades por status', 'ações por WhatsApp, telefone ou e-mail', 'métricas de recuperação', 'controle de follow-up comercial']
      },
      {
        icon: <Ticket size={32} className="text-primary-custom" />,
        title: 'Cupons, promoções e combos',
        description: 'Crie cupons, ofertas por produto, promoções por categoria e combos para vender mais sem depender de ações manuais.',
        benefits: ['campanhas promocionais', 'combos fixos e montáveis', 'descontos por tempo limitado', 'aumento da conversão de pedidos']
      }
    ]
  },
  {
    id: 'automacao',
    title: 'Automação de atendimento',
    features: [
      {
        icon: <Smartphone size={32} className="text-primary-custom" />,
        title: 'Cardápio digital inteligente',
        description: 'Disponibilize seu cardápio online para que seus clientes façam pedidos diretamente pelo celular, sem precisar baixar aplicativos.',
        benefits: ['acesso por link ou QR Code', 'fotos e descrição dos produtos', 'pedidos automáticos', 'pagamento online integrado']
      },
      {
        icon: <Bot size={32} className="text-primary-custom" />,
        title: 'WhatsApp com Evolution API e N8N',
        description: 'Automatize conversas, envie o link do cardápio e organize o atendimento humano com fluxos integrados ao backend.',
        benefits: ['atendimento automático', 'orquestração com N8N', 'integração Evolution API', 'mais pedidos sem aumentar equipe']
      },
      {
        icon: <QrCode size={32} className="text-primary-custom" />,
        title: 'Cardápio QR Code para mesas',
        description: 'Seus clientes escaneiam o QR Code da mesa e fazem pedidos diretamente pelo celular.',
        benefits: ['menos espera por atendimento', 'pedidos mais rápidos', 'redução de erros na comanda']
      },
      {
        icon: <Monitor size={32} className="text-primary-custom" />,
        title: 'Autoatendimento no balcão',
        description: 'Permita que seus clientes escolham produtos e façam pedidos diretamente no balcão de forma rápida e simples.',
        benefits: ['redução de filas', 'atendimento mais rápido', 'aumento da produtividade da equipe']
      },
      {
        icon: <Calendar size={32} className="text-primary-custom" />,
        title: 'Pedidos agendados',
        description: 'Permita que seus clientes escolham o melhor horário para receber o pedido.',
        benefits: ['organização da produção', 'mais previsibilidade', 'melhor experiência para o cliente']
      },
      {
        icon: <PlugZap size={32} className="text-primary-custom" />,
        title: 'Integração iFood',
        description: 'Conecte catálogo, pedidos, eventos e mapeamentos para operar marketplaces com mais controle.',
        benefits: ['sincronização de catálogo', 'eventos de pedidos', 'mapeamento de itens', 'menos retrabalho operacional']
      }
    ]
  },
  {
    id: 'gestao',
    title: 'Sistema de gestão',
    features: [
      {
        icon: <DollarSign size={32} className="text-primary-custom" />,
        title: 'Gestão financeira integrada',
        description: 'Controle vendas, fluxo de caixa e relatórios financeiros em um único sistema.',
        benefits: ['acompanhamento de faturamento', 'relatórios completos', 'controle de caixa']
      },
      {
        icon: <Package size={32} className="text-primary-custom" />,
        title: 'Gestão de estoque inteligente',
        description: 'Controle seus ingredientes e produtos em tempo real para evitar desperdícios e falta de itens.',
        benefits: ['controle automático de estoque', 'alerta de reposição', 'redução de desperdício']
      },
      {
        icon: <ChefHat size={32} className="text-primary-custom" />,
        title: 'Engenharia de cardápio e ficha técnica',
        description: 'Cadastre receitas, ingredientes, quantidades e custos para padronizar produção e entender a margem de cada produto.',
        benefits: ['receitas por produto', 'cálculo de custo', 'insumos e unidades', 'produção mais padronizada']
      },
      {
        icon: <MapPin size={32} className="text-primary-custom" />,
        title: 'Gestão de entregadores',
        description: 'Organize suas entregas e acompanhe os pedidos até a casa do cliente.',
        benefits: ['controle de entregadores', 'rotas mais rápidas', 'entregas mais eficientes']
      },
      {
        icon: <Tablet size={32} className="text-primary-custom" />,
        title: 'Controle completo de mesas',
        description: 'Gerencie comandas, mesas abertas e pedidos do salão de forma simples e organizada.',
        benefits: ['controle do atendimento', 'organização do salão', 'mais eficiência no serviço']
      },
      {
        icon: <Monitor size={32} className="text-primary-custom" />,
        title: 'Monitor de pedidos na cozinha',
        description: 'Os pedidos aparecem em telas na cozinha em tempo real, organizando a produção e evitando erros.',
        benefits: ['pedidos organizados', 'prioridade de preparo', 'mais velocidade na cozinha']
      },
      {
        icon: <BarChart3 size={32} className="text-primary-custom" />,
        title: 'Dashboards e relatórios',
        description: 'Acompanhe vendas, operação, clientes e indicadores para tomar decisões com mais clareza.',
        benefits: ['visão de faturamento', 'resumos operacionais', 'indicadores por período', 'decisão baseada em dados']
      }
    ]
  }
];

const Features = () => {
  const [activeCategory, setActiveCategory] = useState(categories[0].id);

  return (
    <Section id="funcionalidades" className="bg-white" data-aos="fade-up">
      <Container>
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="fw-bold mb-3">Plataforma completa para Delivery</h2>
          <p className="text-secondary lead">Tudo o que você precisa para automatizar seu restaurante e vender mais</p>
        </div>

        <div className="d-flex flex-wrap justify-content-center gap-2 mb-5 features-tabs">
          {categories.map((category) => (
            <button
              key={category.id}
              className={`btn px-4 py-2 fw-semibold transition-all ${
                activeCategory === category.id 
                ? 'btn-primary-custom shadow' 
                : 'btn-outline-custom border-0'
              }`}
              onClick={() => setActiveCategory(category.id)}
            >
              {category.title}
            </button>
          ))}
        </div>

        <div className="row g-4">
          {categories.find(c => c.id === activeCategory).features.map((feature, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <Card className="h-100 p-4 border-0 shadow-sm hover-up">
                <div className="bg-primary-light d-inline-flex p-3 rounded-3 mb-4">
                  {feature.icon}
                </div>
                <h3 className="h5 fw-bold mb-3">{feature.title}</h3>
                <p className="text-secondary mb-4 small">{feature.description}</p>
                <div className="mt-auto">
                  <ul className="list-unstyled mb-0">
                    {feature.benefits.map((benefit, bIndex) => (
                      <li key={bIndex} className="d-flex align-items-start mb-2 small">
                        <Check size={16} className="text-success me-2 mt-1 flex-shrink-0" />
                        <span className="text-secondary">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </Container>
    </Section>
  );
};

export default Features;
